import React, { useState, useEffect } from "react";
export default function Home({ match }) {
  window.location.href = "/admin";
  return <></>;
}
